import {Component} from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DragNDropModal from '../extra_credit/drag_n_drop_modal';
import LoanCalculatorModal from '../extra_credit/loan_calculator_modal';
import SavingsOverTimeModal from '../extra_credit/savings_over_time_modal';
// input data 
import ExtraCreditConfigFile from '../extra_credit/Datasets/extra_credit_config_file';
import SavingMoneyChallenge1ResultsText from './badgesText/saving_money_challenge1_results_text';
import LoanChallenge1ResultsText from './badgesText/loan_challenge1_results_text';
// functions
import { createColumnArray } from '../../objects/DragNDrop/createColumnArray_function';
import { calcColumnScore } from '../../objects/DragNDrop/calcColumnScore_function';
import { calcColumnAmt } from '../../objects/DragNDrop/calcColumnAmount_function';
import { calcItemScore } from '../../objects/DragNDrop/calcItemScore_function';
import { doubleToStringMonthly } from '../../objects/CommonUse/double_functions';
import { createTaxAmtExpense } from '../../objects/AssetsExpenses/create_tax_amt_expense';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import { createResultsArray } from '../extra_credit/objects/createResultsArray_function';
import buildBadgeDragNDropDataset from './objects/build_badge_dragNDrop_dataset';
import { addChangeSalaryAsset } from '../../objects/AssetsExpenses/add_change_salary_asset';
import buildUrl from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import ConfigFile from '../../datasets/config_file';
import createEventTrackerUpdateObject from '../../objects/CommonUse/create_eventTracker_update_object';
import TaxChangeEventTracker from '../../datasets/tax_change_event_tracker';
import { calcMonthlyIncome } from '../../objects/CommonUse/calcMonthlyIncome';
import BadgesInfoDataset from './badgesDatasets/badges_info_dataset';



class EarnBadge extends Component {
  
    constructor(props) {  
        super(props);
        this.gameInfo = this.props.gameInfo;
        this.state = {
            headers: setHeadersForFetch(),
            openSw: true,
            challengeScore: 0,
            challengeComplete: false,
            tableObject: [],
            freezeFlag: false,
            displayAlert: false,
            title: ExtraCreditConfigFile.general.title,
            modalSw: false,
            environment: Config.dataURL.currentEnv,
            subProcess: "earnBadge",
            eventTracker: ConfigFile.general.eventTracker,
        }
        this.dragNDrop = {};
        this.hintTable = [];
        this.currentStatus = "";
        this.challengeScore = 0;
        this.col1Text = "";
        this.tableNbrRows = 0;
        this.tableObject = [];
        this.modalMessage = "";
        this.nbrTries = 1;
        this.hintNbr = 0;
        this.calculatorStatus = "";
        this.calculateOnly = false;
        this.badgeOpened = false;
        this.openBadgeChallenge();
    }
       
    openBadgeChallenge() {
        const badgeName = this.props.parameters.badgeName;
        const badgePartNbr = this.props.parameters.partNbr;
        let dragNDropObject = buildBadgeDragNDropDataset(this.props.nextBadge, badgeName, badgePartNbr);
        this.dragNDrop = dragNDropObject.dragNDropDataset;
        this.hintTable = JSON.parse(JSON.stringify(dragNDropObject.hintTable));
        this.currentStatus = "OpenChallenge";
        this.badgeOpened = true;
        if (this.is_mounted === true){
            this.setState({openSw: true});
        }
    }
    
    closeChallenge() {
        this.setState({openSw: false});
        this.props.onClose("earnBadge");
        this.props.onNavigate("game-board");
    }
    
    processChallengeResponse() {
        this.scoreChallenge();
        if (+this.challengeScore >= 100) {
            if (this.props.nextBadge === "9" || this.props.nextBadge === "11"){
                if (this.props.nextBadge === "9"){
                    this.col1Text = [
                        "Total Amt Out-of-Pocket", "Total Amt of Savings" ];
                    this.dragNDrop.introText = SavingMoneyChallenge1ResultsText;
                    this.tableNbrRows = 2;
                }else{
                    this.col1Text=["Calculated Amount"];
                    this.dragNDrop.introText = LoanChallenge1ResultsText;
                    this.tableNbrRows = 1;
                }
                this.tableObject=createResultsArray(this.columnArray);
                this.dragNDrop.buttonType = "Continue";
                this.setState({freezeFlag: true});
            }else{
                this.modalMessage = "";
                this.setState({openSw: false});
                this.finishChallenge("success");
            }
        } else {
            this.nbrTries += 1;
            if (this.nbrTries > 3){
                    this.setState({openSw: false});
                  this.finishChallenge("failed")
            }else{
                this.modalMessage= "Not quite right... Try again.";
                if (this.hintNbr < this.hintTable.length){
                    this.hintNbr = this.hintTable.length;
                }
                if (this.props.nextBadge === "4"){
                    let hintLine1 = JSON.parse(JSON.stringify(this.hintTable[0]));
                    let totalAmtFmt = doubleToStringMonthly(this.totalColumnAmt);
                    hintLine1 = (hintLine1).replace("||dollarAmt||", totalAmtFmt)
                    this.hintTable[0] = hintLine1;
                }
                this.setState({displayAlert: true});
            }
        } 
    }

    scoreChallenge(){ 
        let nbrColumns = this.props.parameters.nbrColumns;
        this.columnArray=createColumnArray(this.dragNDrop.cookieNamePfx, nbrColumns); 
        if (this.props.nextBadge === 3 || this.props.nextBadge === 6){
            this.challengeScore = calcItemScore(this.columnArray);
        }else{
            this.challengeScore = calcColumnScore(this.columnArray);
        }
        // this code is only invoked for badge #4 (priorities challenge #2)
        // but can be applied to other badges if min amount and max amount
        // are provided.
        if (this.dragNDrop.inputData.minAmount  &&
            this.dragNDrop.inputData.maxAmount ){
                this.minAmount = this.dragNDrop.inputData.minAmount;
                this.maxAmount = this.dragNDrop.inputData.maxAmount;
                this.totalColumnAmt = calcColumnAmt(this.columnArray, "column-1");
                if (this.totalColumnAmt > this.maxAmount ||
                    this.totalColumnAmt < this.minAmount){
                        this.challengeScore = 0;
                }
        }
    }

    openCalculator(){
        this.calculateOnly = true;
        if (this.dragNDrop.calculatorType === "Savings"){
            this.calculatorStatus = "OpenSavingsCalculator";
        }else{
            this.calculatorStatus = "OpenLoanCalculator";
        }
        this.setState({openCalculatorSw: true});
    }
      
    closeCalculator() {
        this.calculatorStatus = "CloseCalculator";
        this.setState({openCalculatorSw: false});
    }

    closeAlert(){
        this.setState({displayAlert: false});
    }
     
    render() {
        this.backgroundURL = this.props.backgroundURL;
    return <>
        <div className="col-8">
            {this.currentStatus === "OpenChallenge" &&
                ReactDOM.createPortal(
                <DragNDropModal show={this.state.openSw} 
                        onClose={() => this.closeChallenge()} 
                        onSave={() => this.processChallengeResponse()}
                        onCalculator={() => this.openCalculator()}
                        onContinue={() => this.finishChallenge("success")}
                        closeAlert={() => this.closeAlert()}
                        inputDataset={this.dragNDrop.inputData}
                        modalSize={this.dragNDrop.modalSize}
                        amountSw={this.dragNDrop.amountSw}
                        modalTitle={this.dragNDrop.modalTitle}
                        buttonType={this.dragNDrop.buttonType}
                        calcType={this.dragNDrop.calculatorType}
                        introText={this.dragNDrop.introText}
                        cookieNamePfx={this.dragNDrop.cookieNamePfx}
                        maxNbr={this.dragNDrop.maxNbrPerColumn}
                        message={this.modalMessage}
                        tableNbrRows={this.tableNbrRows}
                        tableCol1Text={this.col1Text}
                        tableObjectRow={this.tableObject}
                        freezeFlag={this.state.freezeFlag}
                        hintTable={this.hintTable}
                        hintNbr={this.hintNbr}
                        displayAlert={this.state.displayAlert}
                    />,
                 document.body
                )
 
            }
            
            {this.calculatorStatus === "OpenSavingsCalculator" ?
                    <SavingsOverTimeModal show={this.state.openCalculatorSw} 
                        exerciseButtons={false}
                        onClose={() => this.closeCalculator()} 
                        calculatorSw ={this.calculateOnly}
                        displayInitialAmt={false}/>
                :
                    null
                }
            {this.calculatorStatus === "OpenLoanCalculator" ?
                    <LoanCalculatorModal show={this.state.openCalculatorSw} 
                        exerciseButtons={false}
                        onClose={() => this.closeCalculator()} 
                        calculatorSw ={this.calculateOnly}/>
                :
                    null
            }
            
            {this.currentStatus === "DisplayBadgeNotEarned" ?
                <Modal show={this.state.modalSw}  onHide={() => this.closeChallenge()}
                    size="sm" animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Good Try!! Badge Not Earned.</Modal.Title> 
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p>You were not able to earn this badge this time.
                        You will have another chance and likely will have
                        more success the next time.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary"   onClick={() => this.closeChallenge()}>
                        Close
                    </Button>
                </Modal.Footer>
                </Modal>
            :
                null
            } 
                            
       </div>
        </>
    }

    componentDidMount(){
        this._isMounted = true;
       
    }

    finishChallenge(status) {
        if (status === "success"){
            this.updateBadgeEarned();
            const badgeObj = 
                {badgesEarned: this.gameInfo.gameData.badgesEarned, imgSrc: this.badgeSlctd.imgSrc}
            this.props.onFinish(badgeObj);
            this.props.onNavigate("game-board");
        }else{
            this.currentStatus = "DisplayBadgeNotEarned";
            this.setState({modalSw: true});
        }  
        this.badgeOpened = false;
    }

    closeAwardInfo(){
        this.props.onNavigate("game-board");
    }

    updateBadgeEarned(){
        this.determineValue();
        this.newBadgeEarned = {badgeCode: this.props.parameters.badgeCode,
            badgeName: this.props.parameters.badgeName,
            awardType: this.props.parameters.awardType,
            awardAmount: this.awardAmount,
            moodPointsEarned: this.moodPointIncrease,
            dateEarned: this.gameInfo.gameData.currentGameDate}
        this.gameInfo.gameData.badgesEarned.push(this.newBadgeEarned);
        this.gameInfo.gameData.currentCash = +this.gameInfo.gameData.currentCash +
            +this.cashIncrease;
        this.removeInvalidCashIcons();
        this.gameInfo.gameData.currentMoodPoints = +this.gameInfo.gameData.currentMoodPoints + +this.moodPointIncrease;
        this.gameInfo.gameData.assetTable = this.newAssetTable;
        this.gameInfo.gameData.expenseTable = this.newExpenseTable;
        this.props.setGameInfo(this.gameInfo.gameData, 'gameData'); 
        const funcName = "updateBadgesEarned";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        const bodyObj = {"badgesEarned": this.gameInfo.gameData.badgesEarned,
            "assetTable": this.gameInfo.gameData.assetTable,
            "expenseTable": this.gameInfo.gameData.expenseTable,
            "currentCash": this.gameInfo.gameData.currentCash,
            "currentMoodPoints": this.gameInfo.gameData.currentMoodPoints,
            "iconTable": this.gameInfo.gameData.iconTable,
        };
        fetch (uri, 
            {method:'PUT', 
              headers: this.state.headers, 
              body: JSON.stringify(bodyObj)})
              .then(response => {
                if (response.ok){
                  response.json().then(data => {
                  const output = JSON.parse(data);
                  const statusCode = output.statusCode;
                  if (output.statusCode === 200){ 
                    // update badges earned successful
                  }else{
                      const errorObj={function: funcName, subProcess: this.state.subProcess, 
                          status: statusCode, message: output.body.message, errorObject: bodyObj};
                      this.props.processError(errorObj);
                  }
              });
            }
        });        
        return;
        
    }

    removeInvalidCashIcons(){
        if (this.gameInfo.gameData.currentCash > 0){
            const checkIndx1 = 
                this.gameInfo.gameData.iconTable.findIndex(elem => elem.iconName === "negativeCash");
            const checkIndx2 =
                this.gameInfo.gameData.iconTable.findIndex(elem => elem.iconName === "savingsTransfer");
            if (checkIndx1 !== -1 || checkIndx2 !== -1){
                if (checkIndx1 !== -1){
                    this.gameInfo.gameData.iconTable.splice(checkIndx1, 1);
                }
                if (checkIndx2 !== -1){
                    this.gameInfo.gameData.iconTable.splice(checkIndx2, 1);
                }
            }
        }
        let incomeObj = calcMonthlyIncome(this.gameInfo.gameData.assetTable, this.gameInfo.gameData.expenseTable,
            this.gameInfo.gameData.loanTable);
        const monthlyIncome = incomeObj.income;
        if (monthlyIncome > 0){
            const checkIndx = 
                this.gameInfo.gameData.iconTable.findIndex(elem => elem.iconName === "negativeNetIncome")
            if (checkIndx !== -1){
                this.gameInfo.gameData.iconTable.splice(checkIndx, 1);
            }
        }
    }

    determineValue(){
        let pctEarned = 0;
        switch (this.nbrTries){
            case 1:
                pctEarned = 100;
                break;
            case 2:
                pctEarned = 80;
                break;
            case 3:
                pctEarned = 60;
                break;
            default:
                break;
        }
        if (this.props.parameters.awardType === "cash"){
            this.cashIncrease = (+this.props.parameters.awardAmount * pctEarned/100).toFixed(2);
            this.awardAmount = this.cashIncrease;
            this.newAssetTable = this.gameInfo.gameData.assetTable;
            this.newExpenseTable = this.gameInfo.gameData.expenseTable;
        }else{
            this.cashIncrease = 0;
            this.salaryIncrease = (+this.props.parameters.awardAmount * pctEarned/100).toFixed(2);
            this.updateAssetTable();
            // update the taxes for the new salary amount
            this.updateExpenseTable();
            this.awardAmount = this.salaryIncrease;
        }
        this.moodPointIncrease = (+this.props.parameters.moodPoints * +pctEarned/100).toFixed(2);
        if (this.state.eventTracker === true){
            this.addToEventArray();
        }
        const badgeInfo = BadgesInfoDataset;
        const badgeIndx = +this.props.nextBadge - 1;
        const badgeCode = badgeInfo[badgeIndx].badgeCode;
        const imgSrc = "./assets/Awards/" + badgeInfo[badgeIndx].pictureName;
        this.badgeSlctd = {id: badgeCode, earned: true, imgSrc: imgSrc};

    }

    updateAssetTable(){
        let newAssetObj = addChangeSalaryAsset(this.gameInfo.gameData.assetTable,
            "BadgeBonus", this.gameInfo.gameData.currentGameDate, this.salaryIncrease,
            this.props.parameters.badgeName);
        this.newAssetTable = newAssetObj.assetTable;
        this.totalSalary = newAssetObj.totalSalary;
    }

    updateExpenseTable(){
        const taxExpenseObj = createTaxAmtExpense(this.gameInfo.gameData.expenseTable, 
            this.gameInfo.gameData.assetTable, 
            this.gameInfo.gameData.currentGameDate);
        this.newExpenseTable = taxExpenseObj.expenseTable;
        if (taxExpenseObj.taxAmtChgd === true){
            this.taxAmt = taxExpenseObj.newTaxAmt;
            this.taxAmtChgd = true
            this.oldTaxExpense = taxExpenseObj.oldTaxExpense
        }
    }

    addToEventArray(){
        this.eventType = "BadgeEarned";
        let category = "";
        let onItem = "";
        let type = "";
        let duration = "";
        let tableItemObj = {};
        let amount = 0;
        if (this.props.parameters.awardType === "salary"){
            category = "salary";
            onItem = "Job Salary";
            duration = "-1";
            type = "flat";
            amount = +this.salaryIncrease;
            tableItemObj = {assetItem: "Salary Bonus - Badge Earned",  assetDesc: this.props.parameters.title,
                assetAmt: "1000", assetStartDate: this.gameInfo.gameData.currentGameDate, 
                assetNbrMonths: -1};
        }else{
            category = "cash";
            onItem = "cash";
            duration = "1";
            type = "flat";
            amount = this.cashIncrease;
        }
        const eventObj = {category: category, on: onItem, duration: duration, value: amount, 
            type: type, title: this.props.parameters.title, tableItemChanged: tableItemObj, 
            moodPoints: this.moodPointIncrease};
        this.saveEventTracker(eventObj);
        if (this.state.eventTracker === true && this.props.parameters.awardType === "salary" &&
            this.taxAmtChgd === true){
            this.eventType = "TaxChange";
            let eventDetail = TaxChangeEventTracker;
            eventDetail.value = this.taxAmt;
            eventDetail.tableItemChanged = this.oldTaxExpense;
            this.saveEventTracker(eventDetail);
        }
    }
    
    saveEventTracker(eventObj) {
        const dataObject = createEventTrackerUpdateObject(this.eventType, this.props.parameters.badgeName,
            this.gameInfo.gameData, eventObj, this.gameInfo.creditCardInfo);
        const funcName = "saveEventTracker";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {
            method:'post',
            headers: this.state.headers,
            body: JSON.stringify(dataObject)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                           // update of event tracker was successful
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: dataObject};
                            this.props.processError(errorObj);
                        }
                    });
                };
            });
    }
    
    
}
export default EarnBadge;